
const links = document.querySelectorAll( '[href="#quick-quote"]' );
const quickQuote = document.getElementById( 'quick-quote' );
const modal = quickQuote.closest( '#modal' );

setUpLinksToModal();
setUpPostcodeSwitcher();
requiredCF7Date();


function setUpLinksToModal() {
    if ( !modal ) return;

    if ( window.location.hash === "#quick-quote" ) {
        modal.dataset.active = "true";
    }

    const modalClose = modal.querySelector( '.modal__close' );
    modalClose.addEventListener( 'click', closeModal );

    modal.addEventListener( 'click', e => {
        if ( e.target === modal ) closeModal();
    })

    links.forEach( link => {
        link.addEventListener( 'click', openModal );
    } );
}

function closeModal() {
    modal.dataset.active = "false";
}

function openModal() {
    modal.dataset.active = "true";
}

function setUpPostcodeSwitcher() {
    const from = quickQuote.querySelector( '[name=from-postcode]' );
    const to = quickQuote.querySelector( '[name=to-postcode]' );
    const switcher = quickQuote.querySelector( '.quiquote__switch' );

    switcher.addEventListener( 'click', () => {
        [from.value, to.value] = [to.value, from.value];
    } );
}

function requiredCF7Date() {
    document.querySelectorAll( '[type=date][aria-required=true]' ).forEach( input => {
        input.setAttribute( 'required', true );
    })
}